import { render, staticRenderFns } from "./CreateProgramAward.vue?vue&type=template&id=373c5709&scoped=true&"
import script from "./CreateProgramAward.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateProgramAward.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateProgramAward.vue?vue&type=style&index=0&id=373c5709&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c5709",
  null
  
)

export default component.exports